import { z } from "zod";
import {
  DocumentMetaTs,
  ImageTs,
  LocaleTs,
} from "../../common";


import { SingleTypes } from "..";
import { useContext } from "react";
import { ContentContext } from "../../content-provider";
import { OmitDocumentMeta } from "@/providers/strapi/client/types";

export type Banner = z.output<typeof BannerTs>;

export const BannerTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  message: z.string(),
  icon: ImageTs,
  localizations: z.array(DocumentMetaTs),
  display: z.boolean()
})

export const BANNER = "banner";
export function useBanner
  // <
  //   K extends keyof Omit<Banner, "id" | "locale" | "localizations" | OmitDocumentMeta>
  // >
  (
  // entity: K,
  // contextKey: string
): Banner[] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`Calculator content not found`)
  const banner = content[BANNER] as Banner[];
  // if (!banner || !banner[entity]) throw new Error(`${entity} content not found`)
  return banner
}
